import type { IPartnerSettings } from '.'


export const RLCZ: IPartnerSettings = {
  partner: 'RLCZ',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://czrlpa-cebap2.raiffleas.cz/broker',
    prep: '',
    production: 'https://czrlpa-cebap1.raiffleas.cz/broker'
  },
  hosts: [
    'czrlpa-cebap2.raiffleas.cz',
    'czrlpa-cebap1.raiffleas.cz'
    //  , 'localhost:44470'
  ]
}
